import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "row full-height" };
const _hoisted_2 = {
    class: "text-caption",
    ref: "rebates-section"
};
const _hoisted_3 = { class: "row bg-positive text-white q-px-xs rounded" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_q_separator = _resolveComponent("q-separator");
    const _component_q_inner_loading = _resolveComponent("q-inner-loading");
    const _component_q_card = _resolveComponent("q-card");
    const _component_router_link = _resolveComponent("router-link");
    return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_q_separator, {
            vertical: "",
            class: "q-my-sm separator-margin"
        }),
        _createVNode(_component_router_link, {
            to: { name: 'Account Rewards' },
            class: "self-center text-right"
        }, {
            default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", {
                        class: _normalizeClass(["row justify-start", {
                                'text-white': _ctx.homeHeader,
                                'grey8-white-text-color': !_ctx.homeHeader
                            }])
                    }, _toDisplayString(_ctx.$t('Credits')) + ":", 3),
                    _createVNode(_component_q_card, { flat: "" }, {
                        default: _withCtx(() => [
                            _createVNode(_component_q_inner_loading, {
                                showing: _ctx.requerying,
                                color: "white"
                            }, null, 8, ["showing"]),
                            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.countryCurrency.country_currency_symbol) + _toDisplayString(_ctx.numberWithCommas(Number(_ctx.profileCashback.country_reward_bal).toFixed(2))) + " " + _toDisplayString(_ctx.profileCashback.country_currency), 1)
                        ]),
                        _: 1
                    })
                ], 512)
            ]),
            _: 1
        })
    ], 512)), [
        [_vShow, _ctx.user]
    ]);
}
